// DEV environment
// export const SERVER_ENV = 'dev';
// export const SERVER_HOST = '/';
// export const SERVER_HOST_URL = 'http://localhost:8080/';

// PROD environment
export const SERVER_ENV = 'pro';
export const SERVER_HOST = '/';
export const SERVER_HOST_URL = 'http://localhost:8080/';
